import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-exit-confirm',
  templateUrl: './exit-confirm.component.html',
  styleUrls: ['./exit-confirm.component.scss']
})
export class ExitConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
